<template>
  <div :style="welcome_theme.wc_fullwidth ? `width: 80%;` : ''">
    <section v-if="surveyInfo">
      <section v-if="allow_webform">
        <template>
          <Default
            v-if="!surveyInfo.enableAuth && surveyInfo.surveyStatus"
            :config="config"
            :surveyInfo="surveyInfo"
            :image="welcome_theme.image"
            :image_url="welcome_theme.image_url"
            :image_size="welcome_theme.image_size"
            :wc_color="welcome_theme.wc_color"
            :wc_bg_title="welcome_theme.wc_bg_title"
            :wc_title="welcome_theme.wc_title"
            :wc_subtitle="welcome_theme.wc_subtitle"
            :wc_justify="welcome_theme.wc_justify"
            :default_theme="welcome_theme.default"
            :wc_fullwidth="welcome_theme.wc_fullwidth"
            :mobile_mode="mobile_mode"
          />

          <OneID
            v-if="surveyInfo.enableAuth && surveyInfo.surveyStatus"
            :config="config"
            :surveyInfo="surveyInfo"
            :image="welcome_theme.image"
            :image_url="welcome_theme.image_url"
            :image_size="welcome_theme.image_size"
            :wc_color="welcome_theme.wc_color"
            :wc_bg_title="welcome_theme.wc_bg_title"
            :wc_title="welcome_theme.wc_title"
            :wc_subtitle="welcome_theme.wc_subtitle"
            :wc_justify="welcome_theme.wc_justify"
            :oneid="welcome_theme.oneid"
            :wc_fullwidth="welcome_theme.wc_fullwidth"
            :mobile_mode="mobile_mode"
          />
          <SurveyClosed
            v-if="!surveyInfo.surveyStatus"
            :config="config"
            :surveyInfo="surveyInfo"
            :image="welcome_theme.image"
            :image_url="welcome_theme.image_url"
            :image_size="welcome_theme.image_size"
            :wc_color="welcome_theme.wc_color"
            :wc_bg_title="welcome_theme.wc_bg_title"
            :wc_title="welcome_theme.wc_title"
            :wc_subtitle="welcome_theme.wc_subtitle"
            :wc_justify="welcome_theme.wc_justify"
            :closed="welcome_theme.closed"
            :wc_fullwidth="welcome_theme.wc_fullwidth"
            :mobile_mode="mobile_mode"
          />
        </template>
      </section>
      <section v-else>
        <template>
          <NotInTime
            :config="config"
            :range_status="range_status"
            :surveyInfo="surveyInfo"
            :image="welcome_theme.image"
            :image_url="welcome_theme.image_url"
            :image_size="welcome_theme.image_size"
            :wc_color="welcome_theme.wc_color"
            :wc_bg_title="welcome_theme.wc_bg_title"
            :wc_title="welcome_theme.wc_title"
            :wc_subtitle="welcome_theme.wc_subtitle"
            :wc_justify="welcome_theme.wc_justify"
            :notintime="welcome_theme.notintime"
            :wc_fullwidth="welcome_theme.wc_fullwidth"
            :mobile_mode="mobile_mode"
          />
        </template>
      </section>
    </section>
    <section v-else>
      <template> </template>
    </section>
  </div>
</template>

<script>
// import Swal from "sweetalert2";
import Default from "../../views/webform/Auth_stage/Default.vue";
import NotInTime from "../../views/webform/Auth_stage/NotInTime.vue";
import OneID from "../../views/webform/Auth_stage/OneID.vue";
import SurveyClosed from "../../views/webform/Auth_stage/SurveyClosed.vue";
export default {
  props: [
    "config",
    "welcome_theme",
    "allow_webform",
    "range_status",
    "surveyInfo",
    "mobile_mode",
  ],
  components: {
    Default,
    NotInTime,
    OneID,
    SurveyClosed,
  },
};
</script>

<style lang="scss" scoped></style>
